<template>
  <transition
    mode="out-in"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    appear>
    <div class="status-bar">
      <div class="container">
        <div class="level is-mobile">
          <!-- blocks -->
          <div class="level-item has-text-centered">
            <span class="menu-label">
              BLOCKS
            </span>
            &nbsp;{{ blocks }}
          </div>
          <!-- last block -->
          <div class="level-item has-text-centered is-hidden-mobile">
            <span class="menu-label">
              LASTEST
            </span>
            &nbsp;{{ lastBlockTime }}
          </div>
          <!-- tx -->
          <div class="level-item has-text-centered">
            <span class="menu-label">
              TX/SEC
            </span>
            &nbsp;{{ transactionPerSecond }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'status-bar',
    computed: {
      ...mapState(['chainStatus']),
      blocks () {
        return this.$utils.addComma(this.chainStatus.blockHeight)
      },
      lastBlockTime () {
        if (this.chainStatus.lastBlockTime) {
          const last = this.chainStatus.lastBlockTime
          const d = new Date()
          const now = d.getTime()
          if (now / 1000 - last < 30) {
            return '' + parseInt(now / 1000 - last) + 's'
          } else {
            return this.$utils.fromNow(last)
          }
        }
      },
      transactionPerSecond () {
        return Number.parseFloat('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .status-bar {
    display: flex;
    background: rgb(249, 249, 249);
    padding: 8px 0;
    border-bottom: 1px solid rgb(238, 238, 238);
    transition: opacity 300ms linear;
    opacity: 1;
  }

  .menu-label {
    margin-top: 1.5px;
    margin-bottom: 0 !important;
  }

  .level-item {
    margin: 0 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/StatusBar.vue